$(document).on("click", ".question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question, .rich-text_custom__richtext.footer_menu_lp p", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question, .rich-text_custom__richtext.footer_menu_lp p').removeClass('active');
    jQuery('.question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question, .rich-text_custom__richtext.footer_menu_lp p').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});

$(document).on("click", ".custom_button", function (e) {
    var video = jQuery(this).parents('.video_wrapper_custom').find('video');
if (jQuery(this).hasClass("active")) {
   jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
    jQuery(this).removeClass('active');
video.trigger('pause');
} else {
video.trigger('play');
  jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
    jQuery(this).addClass('active');
}
});

$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "#collectiontab .tab-title", function (e) {
  e.preventDefault();
$('.products_relative_slider .slick-slider').slick('refresh');
});


jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});



function isScrolledIntoView2(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
docViewBottom = docViewBottom-($(window).height())+($(elem).height())+350;
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom));
}


$(window).scroll(function () {


    $('.custom_counter .icons_with_text_flex').each(function () {
      var this_element =  $(this);
      if (this_element.hasClass("start_count")) {
} else {
        if (isScrolledIntoView2(this) === true) {
            this_element.addClass('start_count');
$('.count_js').each(function () {
    $(this).prop('Counter', 0).animate({
            Counter: $(this).data('value')
        }, {
        duration: 1500,
        easing: 'swing',
        step: function (now) {                      
            $(this).text(Math.ceil(now));
        }
    });
});
        }
      }
    });
});




$(document).on("click", '.menu_middle_custom_item', function(e) { 
var data_tab = $(this).attr('data_tab');
$('.custom_products_popup[data_tab="'+data_tab+'"]').addClass('active');
});

$(document).on("click", '.close_submenu', function(e) { 
$('.custom_products_popup').removeClass('active');
});





$(document).on("click", ".quantity_plus", function (e) {
  var input = $(this).parents(".label_quantity").find("input");
  var current_value = parseInt(input.val());
  var new_value = parseInt(current_value + 1);
  input.val(new_value);

  var this_element = jQuery(".cart-drawer__inner");
  this_element.addClass("loading_hk");
  var id = input.attr("variant_id");
  var selling_plan = input.attr("selling_plan");
  var line = input.attr("line");
  var quantity = input.val();
  var current_url = location.href;
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      line: line,
      quantity: quantity,
      id: id,
      selling_plan: selling_plan,
    },
    dataType: "json",
    success: function (data) {
      $.ajax({
        url: current_url,
        data: "",
        type: "GET",
        dataType: "html",
        success: function (data) {
          $("#cart-drawer").html(
            $("#cart-drawer", data).html()
          );
        },
        error: function (xhr, status) {},
        complete: function (xhr, status) {},
      });
    },
  });
});

$(document).on("click", ".quantity_minus", function (e) {
  var input = $(this).parents(".label_quantity").find("input");
  var current_value = parseInt(input.val());
  var new_value = parseInt(current_value - 1);
  input.val(new_value);
  var current = parseInt(0);

  var this_element = jQuery(".cart-drawer__inner");
  this_element.addClass("loading_hk");
  var id = input.attr("variant_id");
  var selling_plan = input.attr("selling_plan");
  var line = input.attr("line");
  var quantity = input.val();
  var current_url = location.href;
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      line: line,
      quantity: quantity,
      id: id,
      selling_plan: selling_plan,
    },
    dataType: "json",
    success: function (data) {
      $.ajax({
        url: current_url,
        data: "",
        type: "GET",
        dataType: "html",
        success: function (data) {
          $("#cart-drawer").html(
            $("#cart-drawer", data).html()
          );
        },
        error: function (xhr, status) {},
        complete: function (xhr, status) {},
      });
    },
  });
});



$(document).on("click", '.close_menu', function(e) { 
$('.navigation-drawer [is=close-button]').trigger('click');
});

$(document).on("click", '.quick_custom-close, .contiue_shopping_quick', function(e) { 
$('quick-buy-drawer').removeAttr('open');
});


$(document).on("click", "a[href='#join_club']", function (e) {
  e.preventDefault();
$('.navigation-drawer [is=close-button]').trigger('click');
  document.querySelector('.join_heading').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("mousemove touchstart", "body", function(e) { 
if( $('.slider_cart_drawer:not(.slick-initialized)').length ) {
    $('.slider_cart_drawer:not(.slick-initialized)').slick({
  dots: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  infinite: true,
    prevArrow: $('.prev_cart_drawer'),
    nextArrow: $('.next_cart_drawer'),
    appendDots: $('.dots_cart_drawer'),
  cssEase:'linear',
  responsive: [
    {
      breakpoint: 915,
      settings: {
        speed: 300,
        slidesToShow:2, 
      }
    }
  ]
});
}
});



$(document).on("click", '.help_sbmit', function (e) {
var text = $(this).next().val();
text = text.trim();
text = text.replace(" ", "+");
var link = 'https://flair.gorgias.help/en-US/search/';
var new_link = link+text+'?page=1';
  location.href=new_link;
});

$('.section_1_lp.section_1_lp_help input.help_input').keypress(function (e) {
if (e.which == '13') {
 $(this).prev().trigger('click');
}});

$(document).on("click", '.search_trigger_button', function (e) {
var text = $(this).next().val();
text = text.trim();
text = text.replace(" ", "+");
var link = '/search';
var new_link = link+'?q='+text;
  location.href=new_link;
});


$('.header_custom_search input').keypress(function (e) {
if (e.which == '13') {
 $(this).prev().trigger('click');
}});



